<template>
<div>

    <div>
      <HeaderAdmin/>
    </div>
    <!-- <div class="container shadows">
          <h1>Upload image for sensor</h1>
          <form method="POST" action="https://app1.zumiot.id/uploadimg" enctype=multipart/form-data>
            
   
              <input type="file" class="form-control-file" name="image">
              <br>
              <button type="submit" class="btn btn-primary mb-2">Upload</button>
        </form>
         
     
    </div>    -->

    <template>
  <div class="container">
    <div class="large-12 medium-12 small-12 cell">
      <h1>Upload file jpg only</h1>
      <label>File
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
      </label>
      <br>
      <button class="btn btn btn-primary" v-on:click="submitFile()">Submit</button>
    </div>
  </div>
</template>

    </div>
</template>

<script>

// @ is an alias to /src
import HeaderAdmin from '@/components/HeaderAdmin.vue'
import axios from 'axios'
import router from './../../router/index.js'

export default {

   data(){
      return {
        file: ''
      }
    },


    name: 'SensorDetail',
      components: {
        HeaderAdmin
      },
    computed:{
      user(){
        return this.$store.getters.user
      },
    },

    
    mounted(){
      // this.$store.dispatch('FilterApplication')
      // this.$store.dispatch('getDevice')
    },

   methods: {
      /*
        Submits the file to the server
      */
      submitFile(){
        /*
                Initialize the form data
            */
            let formData = new FormData();

            /*
                Add the form data we need to submit
            */
           
            var newFileName = window.location.pathname.split("/").pop() + ".jpg"
            formData.append('image', this.file, newFileName)

            axios.post( 'https://api.kompasbontang.id/uploadimg',
            // axios.post( 'http://localhost:5000/uploadimg',
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
            ).then(function(){
          console.log('SUCCESS!!');
          
        
        })
        .catch(function(){
          console.log('FAILURE!!');
        });

        router.push({ name: 'dashboard_sensor' })

      },

      /*
        Handles a change on the file upload
      */
      handleFileUpload(){
        this.file = this.$refs.file.files[0];
      }
   }
  
}
</script>



<style >
.container{
  padding-top: 100px;
}
</style>
